import { _ } from "libs";

import React, { useContext } from "react";
import ReservationPageContext from "./reservationPageContext";
import { Link } from "react-router-dom";
import ChatLink from "../../chatLink";

const Confirmation = () => {
	const pageContext = useContext(ReservationPageContext);
	const { reservation, clearReservationContext, widgetMode } = pageContext;

	let partnerNames = [];
	let partnerIds = [];
	reservation.result.players.forEach((player) => {
		if (player.playerId !== reservation.result.ownerId) {
			partnerNames.push(player.firstName);
			partnerIds.push(player.playerId);
		}
	});

	return (
		<div className="createReservation wizard successfulBooking">
			<div className="wizardHeader">
				<div className="close" onClick={clearReservationContext} />
				<div className="title">{_("bookingWizard.confirmation.title")}</div>
			</div>
			<div className="wizardBody vertical">
				<div className="symbol checkmark" />
				<h3>{_("bookingWizard.confirmation.heading")}</h3>
				<p>
					{partnerNames.length === 0
						? _("bookingWizard.confirmation.description")
						: _("bookingWizard.confirmation.descriptionWithPartners", null, {
								partnerNames: partnerNames.join(","),
						  })}
				</p>
				<p>
					<Link
						to={`/reservations/active/${reservation.result.reservationId}`}
						className="button orange"
						target={widgetMode ? "_blank" : "_self"}
					>
						{_("bookingWizard.confirmation.viewReservationBtn")}
					</Link>
				</p>
				<div className="options">
					{/* DESCOPED
					<p>
						<a
							onClick={() => {
								alert("TODO");
							}}
						>
							{_("bookingWizard.confirmation.shareReservationLink")}
						</a>
					</p>
						*/}
					{partnerNames.length > 0 ? (
						<p>
							<ChatLink
								className="link"
								ids={partnerIds}
								label={_("bookingWizard.confirmation.messagePartnerBtn")}
							/>
						</p>
					) : null}
					{/* DESCOPED
					<p>
						<a
							onClick={() => {
								alert("TODO");
							}}
						>
							{_("bookingWizard.confirmation.addToCalendarLink")}
							Add to Calendar
						</a>
					</p>
						*/}
				</div>
			</div>
		</div>
	);
};

export default Confirmation;
